import React from 'react'
import { Loading } from 'src/components/framework/ui/loading'

import * as styles from './styles.module.scss'

const LazyComponent = React.lazy(async () => import('./price-chart'))

export const LazyPriceChart: React.FC = () => {
  const isSSR = typeof window === 'undefined'
  return (
    <>
      {!isSSR && (
        <React.Suspense fallback={<Loading className={styles.loader} />}>
          <LazyComponent />
        </React.Suspense>
      )}
    </>
  )
}
